import { useSelector } from "react-redux";
import { getDomains } from "../../selectors/projects";
import { useMemo } from "react";
import { getZoneidFromRegionName } from "../../app_shared_functions";

const useZoneId = (region: string | undefined) => {
  const domains = useSelector(getDomains);
  return useMemo(() => {
    if (!region) return;
    return getZoneidFromRegionName(region, domains);
  }, [region, domains]);
};
export default useZoneId;
